<div class="stepper w-full h-full flex">
  <nav *ngIf="initialStepper['stepper'] && initialStepper['stepper'].length > 0" class="steps-list aside-bg-color h-full w-56">
    <ul class="step-list flex flex-col justify-center h-full w-56">
      <li
        class="p-4 mb-2 rounded-md text-sm font-bold cursor-pointer flex space-x-2.5 items-center"
        *ngFor="let step of initialStepper['stepper']; let i = index"
        [ngClass]="{ selected: step['selected'], 'text-gray-500': disableButtons }"
        (click)="showSelectedStepper(step, i)"
      >
        <span class="rounded-full text-[8px] px-2 py-0 border-2 border-amber-700" [ngClass]="{ 'border-gray-500': stepperFormGroups.invalid || disableButtons }" *ngIf="!step.visited">
          {{ i + 1 }}
        </span>
        <mat-icon *ngIf="step.visited"><span class="checked">check_circle</span></mat-icon>
        <span>{{ step?.stepperName }}</span>
      </li>
    </ul>
  </nav>

  <div class="step-details modal-body relative">
    <header class="header modal-header flex flex-col gap-2 place-content-between">
      <div class="flex justify-between">
        <h3 class="modal-subline py-1" [innerHTML]="initialStepper.stepLabel"></h3>
        <button mat-icon-button class="button-close" (click)="closeModal()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div *ngIf="stepperHeader" class="flex items-baseline justify-between">
        <h2 class="modal-headline">
          {{ stepperHeader }}
        </h2>
      </div>
      <div *ngIf="stepperHeader && multipleAssetRelationFlag" class="flex items-baseline justify-between" i18n>
        Only common relations among all selected assets are displayed here. Please note that some assets may have individual relations additionally.
      </div>
    </header>

    <div class="step-data-form modal-main">
      <div class="w-full h-full formFields">
        <form class="flex flex-col w-full h-full" action="" [formGroup]="stepperFormGroups" (keydown.enter)="$event.preventDefault()">
          <ng-content select="[topAreaSlot]"></ng-content>

          <div class="stepper-wrapper">
            <ng-content select="[leftAreaSlot]"></ng-content>

            <ng-template ngFor let-step [ngForOf]="initialStepper['stepper']" let-i="index">
              <ng-template [ngIf]="step['selected']">
                <ng-template [ngIf]="step['stepperGroupName']">
                  <div [class]="'sections section-' + step['stepperGroupName']" [formGroupName]="step['stepperGroupName']">
                    <fieldset class="field-section-group -mx-4">
                      <ng-template ngFor let-formField [ngForOf]="step['formFields']">
                        <ng-template [ngIf]="!formField.assetType || formField.assetType === currentAssetType">
                          <div
                            [ngSwitch]="formField['fieldType']"
                            class="field-control inline-block"
                            [ngClass]="[formField['widthClass'], !formField.visible ? 'hidden' : '']"
                            id="stepper-dialog_{{ formField['formFieldName'] }}"
                          >
                            <ng-container *ngSwitchCase="'text'">
                              <div class="input-box mx-4">
                                <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                                @if (brandingKey === CustomClients.VKB && formField['infotextExternalLink']) {
                                  <span *ngIf="formField['infotext']" class="pl-3 field-label align-bottom">
                                    <mat-icon class="text-[#1212128F] text-[1.4rem] align-bottom" [matTooltip]="formField['infotext']" matTooltipClass="tooltip-list">info</mat-icon>
                                  </span>
                                  <span class="pl-1 field-label align-bottom">
                                    <span class="icon-button" role="button" tabindex="0" (click)="openNamingGuidelines()">
                                      <mat-icon class="material-icons-outlined align-bottom text-[1.2rem]">launch</mat-icon>
                                      Benamungskonzept
                                    </span>
                                  </span>
                                } @else {
                                  <span *ngIf="formField['infotext']" class="pl-3 field-label align-bottom">
                                    <mat-icon class="text-[#1212128F] text-[1.4rem] align-bottom" [matTooltip]="formField['infotext']" matTooltipClass="tooltip-list">info</mat-icon>
                                  </span>
                                }
                                <mat-form-field appearance="outline" color="primary" class="input-template template-name w-full">
                                  <input
                                    autocomplete="off"
                                    matInput
                                    [type]="formField['inputType'] || ''"
                                    [name]="formField['formFieldName']"
                                    [formControlName]="formField['formFieldName']"
                                    [placeholder]="formField['placeholder'] || ''"
                                    [disabled]="!!formField['disable']"
                                    (blur)="trimFormControlValue(formField['formFieldName'], step['stepperGroupName'])"
                                  />
                                  <mat-error *ngIf="stepperFormGroups.controls[step['stepperGroupName']].get(formField['formFieldName'])?.errors?.['required']">
                                    {{ formField['fieldLabel'] + ' ' + textIsRequired }}
                                  </mat-error>
                                  <mat-error *ngIf="stepperFormGroups.controls[step['stepperGroupName']].get(formField['formFieldName'])?.hasError('invalidEmail')" i18n> Invalid email </mat-error>
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngSwitchCase="'number'">
                              <div class="input-box mx-4">
                                <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                                <mat-form-field appearance="outline" color="primary" class="input-template template-name w-full" [ngClass]="!formControlValidState ? step.stepperGroupName : ''">
                                  <input
                                    autocomplete="off"
                                    matInput
                                    [type]="formField['inputType'] || ''"
                                    [name]="formField['formFieldName']"
                                    [formControlName]="formField['formFieldName']"
                                    [placeholder]="formField['placeholder'] || ''"
                                    [disabled]="!!formField['disable']"
                                    pattern="[0-9\-]*"
                                    (keypress)="restrictInput($event)"
                                  />
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <div *ngSwitchCase="'email'" class="input-box mx-4">
                              <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                              <sp-user-email-input-autocomplete
                                [ngClass]="{ invalidField: getFieldValidation(stepperFormGroups.controls[step['stepperGroupName']].get(formField['formFieldName'])) }"
                                [formControlName]="formField['formFieldName']"
                                [users]="users"
                                [enableChips]="true"
                                (selectedUserArray)="userSelected($event)"
                              ></sp-user-email-input-autocomplete>
                              <div class="mat-error ml-3 -mt-5 text-xs" *ngIf="getFieldValidation(stepperFormGroups.controls[step['stepperGroupName']].get(formField['formFieldName']))">
                                {{ formField['fieldLabel'] + ' ' + textIsRequired }}
                              </div>
                            </div>

                            <div *ngSwitchCase="'dropdown'" class="mx-4">
                              <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required || formField.mandatory ? '*' : '' }}</span>
                              <span *ngIf="formField['infotext']" class="pl-3 field-label align-bottom">
                                <mat-icon class="text-[#1212128F] text-[1.4rem] align-bottom" [matTooltip]="formField['infotext']" matTooltipClass="tooltip-list">info</mat-icon>
                              </span>
                              <sp-mat-select-search
                                class="w-full"
                                [formControlName]="formField['formFieldName']"
                                [placeholder]="formField['placeholder'] || ''"
                                [config]="{
                                  search: formField['dropDownSearch'],
                                  inlineImage: formField['inlineImage'],
                                  multiple: formField['multiple'] || false,
                                  disableSingleSelect: formField?.disableSingleSelect || false,
                                  sortDataSource: formField['sortDataSource'],
                                  required: stepperFormGroups.controls[step['stepperGroupName']].get(formField['formFieldName'])?.errors?.['required'],
                                  requiredText: formField['fieldLabel'] + ' ' + textIsRequired,
                                }"
                                [disabledField]="!!formField['disable']"
                                [dataSource]="formField['options'] || []"
                                [attrDataTestId]="'stepper-dialog_' + formField['formFieldName']"
                                (selectedChange)="onValueChange($event, formField['formFieldName'], formField, step)"
                                (removeChip)="removeMultiSelectChip($event, step.stepperGroupName, formField['formFieldName'])"
                              ></sp-mat-select-search>
                            </div>

                            <div *ngSwitchCase="'textarea'" class="input-box mx-4 mb-4">
                              <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                              <div>
                                <sp-editor
                                  id="textareaEditor"
                                  class="block"
                                  [formControlName]="formField['formFieldName']"
                                  [placeholder]="formField['placeholder'] || ''"
                                  [taggingOptions]="taggingOptions"
                                  (descriptionText)="editorDescriptionText($event)"
                                >
                                </sp-editor>
                                <mat-error class="text-xs pl-3" *ngIf="getFieldValidation(stepperFormGroups.controls[step['stepperGroupName']].get(formField['formFieldName']))">
                                  {{ formField['fieldLabel'] + ' ' + textIsRequired }}
                                </mat-error>
                              </div>
                            </div>
                            <div class="input-box mx-4 mb-4" *ngSwitchCase="'label'">
                              <span class="field-label text-xl" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}</span>
                            </div>

                            <div *ngSwitchCase="'multiSelectChip'" class="mx-4">
                              <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                              <span *ngIf="formField['infotext']" class="pl-3 field-label align-bottom">
                                <mat-icon class="text-[#1212128F] text-[1.4rem] align-bottom" [matTooltip]="formField['infotext']" matTooltipClass="tooltip-list">info</mat-icon>
                              </span>
                              <sp-mat-select-search
                                class="w-full"
                                [formControlName]="formField['formFieldName']"
                                [dataSource]="formField['options'] || []"
                                [placeholder]="formField['placeholder'] || ''"
                                [config]="{
                                  search: true,
                                  multiple: true,
                                  sortDataSource: formField.sortDataSource,
                                  enableMatOptGroup: formField.enableMatOptGroup ? formField.enableMatOptGroup : false,
                                  required: stepperFormGroups.controls[step.stepperGroupName].get(formField['formFieldName'])?.errors?.['required'],
                                  requiredText: formField['fieldLabel'] + ' ' + textIsRequired,
                                  enableSecondPartLabel: false,
                                }"
                                [disabledField]="!!formField['disable']"
                                [showAvatar]="formField['showAvatar']"
                                (removeChip)="removeMultiSelectChip($event, step.stepperGroupName, formField['formFieldName'])"
                              ></sp-mat-select-search>
                            </div>

                            <div *ngSwitchCase="'treeHierarchy'" class="input-box mx-4">
                              <sp-mat-tree
                                [matTreeDataSource]="stepperFormGroups.controls[step['stepperGroupName']].get(formField['formFieldName'])?.value"
                                [selectAllCheckboxDefault]="matTreeCheckbox"
                                [required]="isMatTreeSelected"
                                (isListChecked)="changeStatus($event, step['stepperGroupName'], formField['formFieldName'])"
                                (nodeList)="selectedFormatList($event)"
                              >
                              </sp-mat-tree>
                              <mat-error *ngIf="isMatTreeSelected">{{ formField['fieldLabel'] + ' ' + textIsRequired }}></mat-error>
                            </div>

                            <div *ngSwitchCase="'checkbox'" class="input-box mx-4">
                              <mat-checkbox
                                class="input-template template-name w-full m-2 mat-form-field-wrapper"
                                (change)="checkboxChanged($event, formField['formFieldName'], step['stepperGroupName'])"
                                [formControlName]="formField['formFieldName']"
                                >{{ formField.fieldLabel }}</mat-checkbox
                              >
                              <div *ngIf="stepperFormGroups.controls[step['stepperGroupName']]?.get(formField['formFieldName'])?.errors?.['required']" class="block error-color ml-3 -mt-5 text-xs">
                                {{ formField['fieldLabel'] + ' ' + textIsRequired }}
                              </div>
                            </div>

                            <div *ngSwitchCase="'date'" class="mx-4">
                              <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                              <span *ngIf="formField['infotext']" class="pl-3 field-label align-bottom">
                                <mat-icon class="text-[#1212128F] text-[1.4rem] align-bottom" [matTooltip]="formField['infotext']" matTooltipClass="tooltip-list">info</mat-icon>
                              </span>
                              <sp-date-picker
                                [formControlName]="formField['formFieldName']"
                                [placeholder]="formField['placeholder']"
                                [dateCssClass]="'input-template template-name w-full'"
                                [fieldLabel]="formField['fieldLabel']"
                                (selectedDate)="onDateSelection($event, formField['formFieldName'], step['stepperGroupName'])"
                              ></sp-date-picker>
                            </div>

                            <div *ngSwitchCase="'autocomplete'" class="mx-4">
                              <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                              <mat-form-field color="primary" class="input-template template-name w-full" appearance="outline">
                                <input type="text" [placeholder]="formField['placeholder'] || ''" matInput [formControlName]="formField['formFieldName']" [matAutocomplete]="auto" />
                                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                                  <mat-option *ngFor="let option of formField['options']" [value]="option.id">
                                    {{ option.name }}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                            </div>

                            <div *ngSwitchCase="'matChipList'" class="mx-4">
                              <p>
                                <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                                @if (brandingKey === CustomClients.VKB) {
                                  <span class="field-label ml-2">(mind. 6 und max. 15 Schlagworte)</span>
                                  <span *ngIf="formField['infotext']" class="pl-3 field-label align-bottom">
                                    <span class="icon-button" role="button" tabindex="0" (click)="openTaggingGuidelines()">
                                      <mat-icon class="material-icons-outlined align-bottom text-[1.2rem]">launch</mat-icon>
                                      Verschlagwortungskonzept
                                    </span>
                                  </span>
                                }
                              </p>
                              <p *ngIf="brandingKey === CustomClients.Vorwerk" class="my-2 text-amber-700" i18n>
                                Please give at least three tags. Search in existing tags first, should you find no suitable tag - create one
                              </p>
                              <p *ngIf="existingAssetListFiles.length > 1" i18n>Shared tags for all assets</p>
                              @if (brandingKey === CustomClients.VKB) {
                                <sp-mat-select-search
                                  *ngIf="brandingKey === CustomClients.VKB"
                                  formControlName="tags"
                                  aria-label="Tags"
                                  [dataSource]="allTagsListOption || []"
                                  [placeholder]="tagPlaceHolderText"
                                  [config]="{
                                    search: true,
                                    required: existingAssetListFiles.length === 1 ? stepperFormGroups.controls[step.stepperGroupName].get(formField['formFieldName'])?.errors?.['required'] : false,
                                    minlength: existingAssetListFiles.length === 1 ? formField.validators?.minLength : 0,
                                    minlengthError: stepperFormGroups.controls[step.stepperGroupName].get(formField['formFieldName'])?.hasError('minlength'),
                                    multiple: true,
                                    tagField: true,
                                    enableSecondPartLabel: false,
                                    requiredText: formField['fieldLabel'] + ' ' + textAreRequired,
                                    minLengthText: minLengthText,
                                  }"
                                  (optionChanged)="tagOptionChanged($event, step.stepperGroupName, formField['formFieldName'])"
                                  (removeChip)="removeTagOnChange($event, step.stepperGroupName, formField['formFieldName'])"
                                ></sp-mat-select-search>
                              } @else {
                                @if ([CustomClients.LufthansaMedialounge].includes(brandingKey)) {
                                  <ul class="mb-3 ml-5 text-amber-700 text-sm list-disc">
                                    <li i18n>Start by typing relevant tags in the search field to match your asset.</li>
                                    <li i18n>If available, select one of the suggested tag groups for more detailed and structured tagging of uploaded assets.</li>
                                    <li i18n>If any individual tags in a group don't apply to your asset, please remove them manually.</li>
                                  </ul>
                                }
                                <sp-chips-grid-row
                                  #tagsChipsGridRow
                                  formControlName="tags"
                                  aria-label="Tags"
                                  [dataSource]="tags"
                                  [autoCompSource]="autoCompTags"
                                  [placeholder]="tagPlaceHolderText"
                                  [tagToHighlight]="tagToHighlight"
                                  [chipInputTooltip]="chipInputTooltipText"
                                  [required]="stepperFormGroups.controls[step['stepperGroupName']].get(formField['formFieldName'])?.errors?.['required']"
                                  [requiredText]="formField['fieldLabel'] + ' ' + textIsRequired"
                                  [matTooltip]="!(AnyAsset | can: 'tagging') ? 'User doesn\'t have access rights to create tags' : ''"
                                  (removeChip)="removeTag($event, step['stepperGroupName'], formField['formFieldName'])"
                                  (matChipInputToken)="add($event, step['stepperGroupName'], formField['formFieldName'])"
                                ></sp-chips-grid-row>
                                <thehubz-cumulated-tags-chip
                                  *ngIf="existingAssetListFiles.length > 1 && cumulatedTags.length > 0"
                                  [tagsObs]="cumulatedTags"
                                  (updateTagObject)="updateTagObject.emit($event)"
                                  (addTagToList)="add($event.selectedTagName || '', step['stepperGroupName'], formField['formFieldName'])"
                                ></thehubz-cumulated-tags-chip>
                                @if (![CustomClients.LufthansaMedialounge].includes(brandingKey)) {
                                  <thehubz-tags-chip
                                    *ngIf="existingAssetListFiles.length === 1"
                                    [tagsObs]="tagsObs"
                                    [tagData]="tagData"
                                    [searchText]="searchText"
                                    [paginator]="paginatorObj"
                                    (paginatorEvent)="paginatorAssignment($event)"
                                    (updateTagName)="updateTagName($event, step['stepperGroupName'], formField['formFieldName'])"
                                    (searchedTagsEvent)="add($event.selectedTagName || '', step['stepperGroupName'], formField['formFieldName'])"
                                  ></thehubz-tags-chip>
                                  <mat-paginator
                                    *ngIf="existingAssetListFiles.length === 1"
                                    [pageSizeOptions]="[paginatorObj.pageSize]"
                                    [hidePageSize]="true"
                                    (page)="onPaginateChange($event)"
                                  ></mat-paginator>
                                }
                              }
                            </div>

                            <div *ngSwitchCase="'matChipListNoAutocomplete'" class="mx-4">
                              <span class="field-label" *ngIf="!formField['hideLabel']">{{ formField['fieldLabel'] }}{{ formField.validators?.required ? '*' : '' }}</span>
                              <sp-chips-grid-row
                                [formControlName]="formField['formFieldName']"
                                [dataSource]="collectionTags"
                                [autoCompSource]="autoCompTags"
                                [placeholder]="collectionTagPlaceHolderText"
                                [subscriptSizing]="'dynamic'"
                                [chipInputTooltip]="chipInputTooltipText"
                                [matTooltip]="!(AnyAsset | can: 'tagging') ? 'User doesn\'t have access rights to create or edit tags' : ''"
                                (removeChip)="removeTag($event, step['stepperGroupName'], formField['formFieldName'])"
                                (matChipInputToken)="addKeyword($event, step['stepperGroupName'], formField['formFieldName'])"
                              ></sp-chips-grid-row>
                              <thehubz-cumulated-tags-chip
                                *ngIf="existingAssetListFiles.length > 1 && cumulatedTags.length > 0"
                                [tagsObs]="cumulatedTags"
                                (updateTagObject)="updateTagObject.emit($event)"
                                (addTagToList)="addKeyword($event.selectedTagName || '', step['stepperGroupName'], formField['formFieldName'])"
                              ></thehubz-cumulated-tags-chip>
                              <thehubz-tags-chip
                                *ngIf="existingAssetListFiles.length === 1"
                                [tagsObs]="tagsObs"
                                [tagData]="tagData"
                                [searchText]="searchText"
                                [paginator]="paginatorObj"
                                (paginatorEvent)="paginatorAssignment($event)"
                                (updateTagName)="updateTagName($event, step['stepperGroupName'], formField['formFieldName'])"
                                (searchedTagsEvent)="addKeyword($event.selectedTagName || '', step['stepperGroupName'], formField['formFieldName'])"
                              ></thehubz-tags-chip>
                              <mat-error class="text-xs pl-3" *ngIf="getFieldValidation(stepperFormGroups.controls[step['stepperGroupName']].get(formField['formFieldName']))">
                                {{ formField['fieldLabel'] + ' ' + textIsRequired }}
                              </mat-error>
                            </div>

                            <div *ngSwitchCase="'confirmationLabel'" class="m-4">
                              <div class="confirmationBox text-2xl font-bold text-left py-4">
                                {{ formField.fieldLabel }}
                              </div>
                            </div>
                            <div *ngSwitchCase="'formArray'" class="m-4">
                              <div class="w-full" [formArrayName]="formField['formFieldName']">
                                <p class="font-bold" *ngIf="!formField['hideLabel']">
                                  <span class="heading">{{ formField['fieldLabel'] }}</span>
                                </p>
                                <div
                                  class="w-full flex justify-between"
                                  [ngClass]="{ 'border-t-2': rowIndex !== 0 }"
                                  *ngFor="let formArrayControls of getControls(formField['formFieldName'], step.stepperGroupName); let rowIndex = index"
                                >
                                  <div class="flex flex-wrap grow items-center" [ngClass]="{ 'pt-4': rowIndex !== 0 }" [formGroupName]="rowIndex">
                                    <ng-template ngFor let-formArrayField [ngForOf]="formField['formFieldGroup']">
                                      <div
                                        [ngSwitch]="formArrayField['fieldType']"
                                        class="field-box flex-1"
                                        [ngClass]="[formArrayField['widthClass'], !formFieldVisibility[formArrayField['formFieldName']][rowIndex] ? 'hidden' : '']"
                                      >
                                        <div class="mx-4 ml-0" *ngSwitchCase="'dropdown'">
                                          <ng-template [ngIf]="[CustomClients.Vorwerk, CustomClients.SEAT].includes(brandingKey)">
                                            <span class="field-label" *ngIf="!formArrayField['hideLabel'] && (rowIndex === 0 || formArrayField['repeatFieldLabel'])">
                                              {{ formArrayField['fieldLabel'] }}{{ formArrayField.validators?.required ? '*' : '' }}
                                            </span>
                                            <sp-mat-select-search
                                              class="w-full"
                                              [formControlName]="formArrayField['formFieldName']"
                                              [dataSource]="
                                                formArrayField.formFieldName === 'agency'
                                                  ? formArrayField['nestedOptions']?.[rowIndex] || formArrayField['options'] || []
                                                  : formArrayField['nestedOptions']?.[rowIndex] || []
                                              "
                                              [placeholder]="formArrayField['placeholder']!"
                                              [config]="{
                                                search: true,
                                                disableSingleSelect: formArrayField?.disableSingleSelect || false,
                                                required: checkFromArrayRequiredValue(rowIndex, step['stepperGroupName'], formField['formFieldName'], formArrayField['formFieldName']),
                                                requiredText: formArrayField['fieldLabel'] + ' ' + textIsRequired,
                                              }"
                                              [disabledField]="!domainsMatchingFlag"
                                              (selectedChange)="formArrayValueChange($event, formArrayField['formFieldName'], formField, rowIndex, step)"
                                              [attrDataTestId]="'stepper-dialog_' + formArrayField['formFieldName']"
                                              [attrName]="'stepName_' + rowIndex"
                                            ></sp-mat-select-search>
                                          </ng-template>
                                          <ng-template [ngIf]="brandingKey === CustomClients.Standard">
                                            <span class="field-label" *ngIf="!formArrayField['hideLabel'] && (rowIndex === 0 || formArrayField['repeatFieldLabel'])">
                                              {{ formArrayField['fieldLabel'] }}{{ formArrayField.validators?.required ? '*' : '' }}
                                            </span>
                                            <sp-mat-select-search
                                              class="w-full"
                                              [formControlName]="formArrayField['formFieldName']"
                                              [dataSource]="formArrayField['options'] || []"
                                              [placeholder]="formArrayField['placeholder']!"
                                              [config]="{ search: true, disableSingleSelect: formArrayField?.disableSingleSelect || false }"
                                              (selectedChange)="formArrayValueChange($event, formArrayField['formFieldName'], formField, rowIndex, step)"
                                              [attrDataTestId]="'stepper-dialog_' + formArrayField['formFieldName']"
                                              [attrName]="'stepName_' + rowIndex"
                                            ></sp-mat-select-search>
                                          </ng-template>

                                          <ng-template [ngIf]="currentFormFieldName === formArrayField['formFieldName']">
                                            <mat-error
                                              class="-mt-6 ml-4 whitespace-nowrap"
                                              *ngIf="checkFromArrayValue(rowIndex, step['stepperGroupName'], formField['formFieldName'], formArrayField['formFieldName'])"
                                              >Duplicate selection!</mat-error
                                            >
                                          </ng-template>
                                        </div>

                                        <div class="mx-4 ml-0" *ngSwitchCase="'text'">
                                          <span class="field-label" *ngIf="!formArrayField['hideLabel']">{{ formArrayField['fieldLabel'] }}{{ formArrayField.validators?.required ? '*' : '' }}</span>
                                          <span *ngIf="formArrayField['infotext']" class="pl-3 field-label align-bottom">
                                            <mat-icon class="text-[#1212128F] text-[1.4rem] align-bottom" [matTooltip]="formArrayField['infotext']" matTooltipClass="tooltip-list">info</mat-icon>
                                          </span>
                                          <mat-form-field appearance="outline" color="primary" class="input-template template-name w-full">
                                            <input
                                              autocomplete="off"
                                              matInput
                                              [type]="formArrayField['inputType'] || ''"
                                              [name]="formArrayField['formFieldName']"
                                              [formControlName]="formArrayField['formFieldName']"
                                              [placeholder]="formArrayField['placeholder'] || ''"
                                              [disabled]="!!formArrayField['disable']"
                                              (blur)="trimFormControlValue(formArrayField['formFieldName'], step['stepperGroupName'])"
                                            />
                                          </mat-form-field>
                                        </div>

                                        <div class="mx-4 ml-0" *ngSwitchCase="'date'">
                                          <span class="field-label" *ngIf="!formArrayField['hideLabel']">{{ formArrayField['fieldLabel'] }}{{ formArrayField.validators?.required ? '*' : '' }}</span>
                                          <span *ngIf="formArrayField['infotext']" class="pl-3 field-label align-bottom">
                                            <mat-icon class="text-[#1212128F] text-[1.4rem] align-bottom" [matTooltip]="formArrayField['infotext']" matTooltipClass="tooltip-list">info</mat-icon>
                                          </span>
                                          <sp-date-picker
                                            [formControlName]="formArrayField['formFieldName']"
                                            [placeholder]="formArrayField['placeholder']"
                                            [dateCssClass]="'input-template template-name w-full'"
                                            [fieldLabel]="formArrayField['fieldLabel']"
                                            (selectedDate)="onDateSelection($event, formArrayField['formFieldName'], step['stepperGroupName'])"
                                          ></sp-date-picker>
                                        </div>
                                      </div>
                                    </ng-template>
                                  </div>
                                  <div class="action-icons flex items-center gap-2" [ngClass]="{ '!items-end pb-5': formField['formFieldName'] === 'domains' }">
                                    <button
                                      mat-icon-button
                                      class="button-icon-primary"
                                      [disabled]="formArrayControlLength === 1"
                                      (click)="removeRow(rowIndex, step.stepperGroupName, formField['formFieldName'], formField['formFieldGroup'])"
                                    >
                                      <mat-icon>delete_outline</mat-icon>
                                    </button>
                                    <button
                                      [ngClass]="{ invisible: !getIsLastIndex(rowIndex, step.stepperGroupName, formField['formFieldName']) }"
                                      mat-icon-button
                                      class="button-icon-primary !inline-flex button-add-entry"
                                      [disabled]="
                                        !domainsMatchingFlag || !((step.noValidationFlag || !disableAddRow[rowIndex]) && getIsLastIndex(rowIndex, step.stepperGroupName, formField['formFieldName']))
                                      "
                                      (click)="addRow(rowIndex, step.stepperGroupName, formField['formFieldName'], formField['formFieldGroup'])"
                                    >
                                      <mat-icon>add</mat-icon>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div *ngSwitchCase="'assetGallery'" class="asset-custom-control-container h-full mx-4">
                              <thehubz-asset-custom-control
                                [selectedAssetIds]="selectedAssetIds"
                                [editAssets]="selectedAssetRelations"
                                [formControlName]="formField['formFieldName']"
                                class="h-full"
                              ></thehubz-asset-custom-control>
                            </div>

                            <div *ngSwitchCase="'assetRelation'" class="mx-4">
                              <thehubz-asset-relations-form-control
                                #assetRelationsFormControl
                                [formControlName]="formField['formFieldName']"
                                [assetsRelation]="relationData"
                                [assets]="stepperFormGroups.get('selectAssets.assetGallery')?.value"
                                [invalidFormState]="invalidFormState.asObservable()"
                              ></thehubz-asset-relations-form-control>
                            </div>
                          </div>
                        </ng-template>
                      </ng-template>
                    </fieldset>
                  </div>
                  <footer class="footer modal-footer">
                    <div class="button-row">
                      <ng-template ngFor let-action [ngForOf]="step['actions']">
                        <ng-container *ngIf="action.visible">
                          <div class="left-actions float-left inline-block" [ngClass]="action['actionClass']" *ngIf="action?.actionTypePosition === 'left'">
                            <button
                              type="button"
                              mat-flat-button
                              class="w-auto button-primary inline-flex gap-1"
                              [ngClass]="[action?.alignIcon === 'right' ? 'icon-right' : '', action?.icon && 'icon-' + action?.icon]"
                              (click)="nextGoToStep(action)"
                            >
                              <mat-icon matSuffix class="material-icons-outlined !m-0" [ngClass]="{ 'order-last': action?.alignIcon === 'right' }" *ngIf="action?.icon !== ''">
                                {{ action?.icon }}
                              </mat-icon>
                              <span>{{ action?.actionLabel }}</span>
                            </button>
                          </div>
                          <div class="right-actions float-right inline-block ml-16" *ngIf="action?.actionTypePosition === 'right'">
                            <button
                              type="submit"
                              mat-flat-button
                              class="w-auto button-primary inline-flex gap-1"
                              [ngClass]="[action?.alignIcon === 'right' ? 'icon-right' : '', action?.icon && 'icon-' + action?.icon]"
                              (click)="nextGoToStep(action, stepperFormGroups.controls[step['stepperGroupName']])"
                            >
                              <mat-icon matSuffix class="material-icons-outlined !m-0" [ngClass]="{ 'order-last': action?.alignIcon === 'right' }" *ngIf="action?.icon && action?.icon !== ''">
                                {{ action?.icon }}
                              </mat-icon>
                              <span>{{ action?.actionLabel }}</span>
                            </button>
                          </div>
                        </ng-container>
                      </ng-template>
                      <div class="clearfix"></div>
                    </div>
                    <div class="button-row mt-2">
                      <div class="left-actions float-right inline-block"><mat-error *ngIf="formControlValidState" i18n>The required fields are missing</mat-error></div>
                    </div>
                  </footer>
                </ng-template>
              </ng-template>
            </ng-template>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
